// ── Validation ──────────────────────────────────────────────────────

const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(email.toLowerCase());
}

// ── Signup confirmation localStorage persistence ────────────────────

export interface ConfirmFormData {
  status: 'initial' | 'error';
  email: string;
  password: string;
  companyName: string;
  userSub: string;
  firstName: string;
  lastName: string;
  invitationId: string;
}

const CONFIRM_KEY = 'confirmFormProcess';
const USER_SUB_KEY = 'userSub';

export function saveConfirmFormData(data: ConfirmFormData): void {
  localStorage.setItem(CONFIRM_KEY, JSON.stringify(data));
}

export function loadConfirmFormData(): ConfirmFormData | null {
  const raw = localStorage.getItem(CONFIRM_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as ConfirmFormData;
    if (parsed.status === 'initial' || parsed.status === 'error') {
      return parsed;
    }
    return null;
  } catch {
    return null;
  }
}

export function clearConfirmFormData(): void {
  localStorage.removeItem(CONFIRM_KEY);
}

export function saveUserSub(email: string, userSub: string): void {
  const raw = localStorage.getItem(USER_SUB_KEY);
  const arr: Array<{ email: string; sub: string }> = raw ? JSON.parse(raw) : [];
  arr.push({ email: email.toLowerCase(), sub: userSub });
  localStorage.setItem(USER_SUB_KEY, JSON.stringify(arr));
}

// ── Invitation ID from URL ──────────────────────────────────────────

export function getInvitationIdFromSearch(search: string): string | undefined {
  if (!search) return undefined;
  const params = new URLSearchParams(search);
  // The old code parsed ?invitationId=xxx or just ?=xxx
  // URLSearchParams handles both standard formats
  return params.entries().next().value?.[1] || undefined;
}
